import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ViewportSize } from '@services/viewport-size.interface';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent implements OnChanges {
  protected cdr = inject(ChangeDetectorRef);

  @Input() viewportSize: ViewportSize | null = null;
  overlayStyles: { [key: string]: string } = {};

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewportSize'] && this.viewportSize) {
      this.updateOverlayStyles();
      this.cdr.detectChanges();
    }
  }

  protected updateOverlayStyles(): void {
    console.log('to be overriden');
  }

  protected onLinkClick(): void {
    console.log('to be overriden');
  }
}
